<div *ngIf="!loading" class="stats-section">
  <h3 class="sim-link center-text stats-title" [class.sim-link]="!hideButton" (click)="toProfile()">My Stats</h3>
  <div class="stats-preview">
    <div class="stats-box">
      <div class="host-stat">
        <span class="stat-num">{{statsObject.total_games}}</span>
        <span class="stat-label">GAMES<br>RUN</span>
      </div>
      <div class="host-stat">
        <span class="stat-num">{{statsObject.venues_hosted_at}}</span>
        <span class="stat-label">VENUES<br>HOSTED</span>
      </div>
    </div>
    <!--<h3 class="last-host-date">Last Hosted On: {{getLastHostDate()}}</h3>-->
  </div>
  <!--<button *ngIf="!hideButton" (click)="toProfile()" class="basic-btn-red">See More</button>-->
</div>

<p *ngIf="err" class="error-message">{{err}}</p>
